import React from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { SidebarProvider } from "./SidebarContext";
import { ToastContainer } from "../ui/Toast";

export const AdminLayout: React.FC = () => (
  <SidebarProvider>
    <div className="flex h-screen overflow-hidden bg-charcoal font-body">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <Header />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
      <ToastContainer />
    </div>
  </SidebarProvider>
);
